export default function (value) {
  switch (value) {
    case 'EUR':
      return '€'
    default:
      return value
  }
}
